import styled, { css } from 'styled-components'
import _ from 'lodash'

import { Flex, FlexProps } from '../Flex'
import { ThemeWrapper } from '../theme'

export interface SpaceProps extends FlexProps {
  // number -> theme space, string -> exact value
  space?: number | string
  direction?: 'horizontal' | 'vertical'
}

const StyledSpace = styled(Flex)<SpaceProps>`
  & > *:not(:last-child) {
    ${({ direction, space, theme }) =>
      direction === 'horizontal'
        ? css`
            margin-right: ${_.isNumber(space) ? theme.space[space] : space};
          `
        : css`
            margin-bottom: ${_.isNumber(space) ? theme.space[space] : space};
          `}
  }
`

const defaultProps: SpaceProps = {
  space: 1,
  direction: 'horizontal'
}

export const Space = ({ children, ...rest }: SpaceProps) => {
  return (
    <ThemeWrapper>
      <StyledSpace {...defaultProps} {...rest}>
        {children}
      </StyledSpace>
    </ThemeWrapper>
  )
}
